import { DiscountManagementImpl } from "../data/DiscountManagementImpl";
import { IDiscountManagementRepository } from "../domain/repositories/IDiscountManagementRepository";
import { DiscountManagementUseCase } from "../domain/useCases/DiscountManagementUseCase";
import { DiscountManagementViewModel } from "../presentation/viewModel/DiscountManagementViewModel";
import { InjectionBinding, InjectionModule } from "app/di/DependencyInjections";

export class DiscountManagementInjection extends InjectionModule {
  private static readonly discountManagementRepositoryToken = Symbol(
    "IDiscountManagementRepository",
  );
  private static readonly discountManagementUseCaseToken = Symbol(
    "DiscountManagementUseCase",
  );
  private static readonly discountManagementViewModelToken = Symbol(
    "DiscountManagementViewModel",
  );

  protected static override bindings: InjectionBinding[] = [
    {
      scope: "otherRepo",
      token: this.discountManagementRepositoryToken,
      useClass: DiscountManagementImpl,
    },
    {
      scope: "otherRepo",
      token: this.discountManagementUseCaseToken,
      useClass: DiscountManagementUseCase,
    },
    {
      scope: "viewModel",
      token: this.discountManagementViewModelToken,
      useClass: DiscountManagementViewModel,
    },
  ];

  static getDiscountManagementRepo(): IDiscountManagementRepository {
    return this.resolve(this.discountManagementRepositoryToken);
  }

  static getDiscountManagementUseCase(): DiscountManagementUseCase {
    return this.resolve(this.discountManagementUseCaseToken);
  }
}
